import { render, staticRenderFns } from "./DepositedEntryDetailsRecuperoAcconti.vue?vue&type=template&id=5c0a2013&scoped=true&"
import script from "./DepositedEntryDetailsRecuperoAcconti.vue?vue&type=script&lang=js&"
export * from "./DepositedEntryDetailsRecuperoAcconti.vue?vue&type=script&lang=js&"
import style0 from "./DepositedEntryDetailsRecuperoAcconti.vue?vue&type=style&index=0&id=5c0a2013&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0a2013",
  null
  
)

export default component.exports